define('pages/message',["jquery", "appquery", "app"], function($, $$, App) {
    $$ = $$("message");

    return {
        init : function(data) {
            var message = data.message || data;
            var init = data.init || $.noop;
            $$('#message').html(message);
            init($$);

            $$('#reloadButton').click(function(){
                location.reload();
            });
        },
        footer : false
    };
});
